import 'whatwg-fetch';
import dayjs from 'dayjs';
import data from '../assets/data/data.json';

function weatherData() {
  return new Promise((resolve) => {
    const city = '3175447'; // Iseo
    const appid = 'bed3dee8334be571f5c81e3ae0408786';
    const link = `https://api.openweathermap.org/data/2.5/weather?id=${city}&APPID=${appid}`;

    return fetch(link)
      .then(res => res.json())
      .then((response) => {
        resolve({
          cachedtime: dayjs().add(12, 'hour').unix(),
          id: response.weather[0].id,
          sunrise: response.sys.sunrise,
          sunset: response.sys.sunset,
        });
      });
  });
}

export default {
  // async FETCH_EVENTSLIST({ commit }) {
  //   let res = true;

  //   await fetchEventsList()
  //     .then(list => commit('SET_EVENTSLIST', list))
  //     .catch(() => { res = false; });

  //   return res;
  // },

  // async FETCH_EVENT({ commit, state }, id) {
  //   let res = true;

  //   await fetchEvent(id, state.lang)
  //     .then(event => commit('ADD_EVENT', event))
  //     .catch(() => { res = false; });

  //   return res;
  // },

  // async FETCH_WEATHER({ commit }) {
  //   await fetchWeather().then(weather => commit('SET_WEATHERDATA', weather));
  // },

  FETCH_EVENTSLIST({ commit }) {
    const res = true;

    commit('SET_EVENTSLIST', data.index);

    return res;
  },

  FETCH_EVENT({ commit, state }, id) {
    const res = true;

    commit('ADD_EVENT', data.events[state.lang][id]);

    return res;
  },

  async FETCH_WEATHER({ commit }) {
    await weatherData().then(res => commit('SET_WEATHERDATA', res));
  },
};



// WEBPACK FOOTER //
// ./src/store/actions.js